import { useEffect, useState } from "react";

import { useShouldShowPlanTrial } from "@/react/hooks/useShouldShowPlanTrial";
import { browserLocalStorage } from "@/react/lib/browserStorage";

const PLAN_TRIAL_OPT_IN_BANNER_DISMISSED_KEY =
  "plan_trial_opt_in_banner_dismissed";

export const usePlanTrialTopBanner = () => {
  const [isDismissed, setIsDismissed] = useState(false);
  const shouldShowPlanTrialOffer = useShouldShowPlanTrial();

  useEffect(() => {
    const dismissed = browserLocalStorage.getItem(
      PLAN_TRIAL_OPT_IN_BANNER_DISMISSED_KEY,
    );
    setIsDismissed(dismissed === "true");
  }, []);

  const handleDismiss = () => {
    browserLocalStorage.setItem(PLAN_TRIAL_OPT_IN_BANNER_DISMISSED_KEY, "true");
    setIsDismissed(true);
  };

  const shouldShowBanner = shouldShowPlanTrialOffer && !isDismissed;

  return {
    shouldShowBanner,
    handleDismiss,
  };
};
